import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { SsoService } from '../sso/sso.service';

import { PersonaModel } from './models/persona.model';

@Injectable({
  providedIn: 'root'
})
export class PersonasService {
  private empresaId: number = this.ssoService.getTicket().Empresa.IdGestion;
  private urlApi = this.ssoService.getTicket().UrlApi;

  public constructor(private http: HttpClient, private ssoService: SsoService) { }

  public async getPersonas(): Promise<PersonaModel[]> {
    let response: PersonaModel[] = [];

    try {
      response = await this.http.get<PersonaModel[]>(
        `${this.urlApi}/api/personas?enteprise=${this.empresaId}&include=all`
      ).toPromise();
    } catch (e) {
      console.log(e);
    }

    return response ? response : [];
  }

  public async savePersona(persona: PersonaModel): Promise<PersonaModel> {
    let response: PersonaModel = null;

    persona.empresa = this.ssoService.getTicket().Empresa.IdGestion;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    try {
      response = await this.http.post<PersonaModel>(
        `${this.urlApi}/api/persona`,
        JSON.stringify(persona),
        httpOptions
      ).toPromise();
    } catch (e) {
      console.log(e);
    }

    return response;
  }

  public async delPersona(id: number): Promise<boolean> {
    try {
      await this.http.delete(
        `${this.urlApi}/api/persona?id=${id}&enterprise=${this.empresaId}`
      ).toPromise();
    } catch (e) {
      console.log(e);
      return false;
    }
    return true;
  }

}
